import React from 'react';

export default class Error extends React.Component {
  render() {
    return (
      <div className="ui basic segment" key={this.props.key}>
        <div className="ui icon center aligned grey header">
          <i className="thumbs down icon" />
          <div className="content">
            {(this.props.error && this.props.error.message) || this.props.error || 'Something went wrong'}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./~/sp-components/components/Error/index.jsx